<span *ngFor="let mainItem of mainItems; let i = index"
      class="skeleton-loader {{ 'skeleton-main-item-' + i }}"
      [ngClass]="{ circle: appearance === 'circle' }">
</span>

<span *ngFor="let subItem of subItems let i = index"
     class="skeleton-loader loader-sub-item {{ 'skeleton-sub-item-' + i }}">
</span>
